<script setup lang="ts">
defineEmits<{
  navbarClose: []
}>()
const { locales, t } = useI18n()
const switchLocalePath = useSwitchLocalePath()
const route = useRoute()
const shouldShowLanguagePicker = computed(
  () => !route.name?.includes('magazine')
)
</script>

<template>
  <div class="mt-auto md:hidden">
    <div v-if="shouldShowLanguagePicker">
      <div
        class="mt-2 mb-2 md:border-none md:pb-0 text-gray-800 hover:underline text-base font-bold"
      >
        {{ t('general.language') }}
      </div>
      <NuxtLink
        v-for="locale in locales"
        :key="locale.code"
        class="mr-4"
        :to="switchLocalePath(locale.code)"
        @click="$emit('navbarClose')"
      >
        {{ locale.label }}
      </NuxtLink>
    </div>
  </div>
</template>

<style lang="postcss">
.router-link-active {
  @apply text-primary;
}
</style>
